import { html, nothing, unsafeCSS } from 'lit';
import { property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { customElement } from '../base-element';
import { PopoverBaseWC } from '../popover/src/popover-base.wc';
import styles from './better-tooltip.scss?inline';

@customElement('ps-better-tooltip')
export class BetterTooltipWC extends PopoverBaseWC {
  static styles = unsafeCSS(styles);

  /**
   * Popover size
   */
  @property({ reflect: true }) size: 'none' | 'xsmall' | 'small' | 'large' =
    'large';

  constructor() {
    super();
    this.distance = 12;
    this.skidding = 8;
    this.hasArrow = true;

    // this.active = true;
    this.triggerAction = 'click-and-hover';
    this.closeOnClickOutside = false;
    this.disableFocusTrap = true;
    // this.keepMounted = true;
    // this.omitPortal = true;
  }

  render() {
    // console.log('better tooltip', this.slotted()?.toString().length);

    return html`
      <div
        id="popover-container"
        class=${classMap({
          'c-tooltip': true,
          'c-tooltip--shown': this.active,
          // [`c-popover--${this.width}-width`]: this.width,
          // [`c-popover--size-${this.size}`]: this.size,
        })}
        style="transform: ${this.transform}"
      >
        <slot class="c-popover__body"></slot>

        <div class="c-tooltip__arrow" id="popover-arrow"></div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'ps-better-tooltip': BetterTooltipWC;
  }
  enum PSElementTagNameMap {
    'ps-better-tooltip' = 'ps-better-tooltip',
  }
}
